import styled from 'styled-components';
// styled-components.
// -----------------------------------------------------------------------------
export const TableHeadRoot = styled.thead ``;
//# sourceMappingURL=TableHead.styled.js.map